<template>
  <h3 class="text-3xl font-semibold mb-10">Production-Ready Serverless</h3>
  <div class="flex flex-col gap-y-4 text-lg">
    <!-- vs. other bootcamps -->
    <ProOrCon v-if="state.vsOtherWorkshops" :isPro=true>
      <p>Shows how these services fit together in production systems.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsOtherWorkshops" :isPro=true>
      <p>Covers testing, CI/CD, security, observability, cost control, and failure handling.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsOtherWorkshops" :isPro=true>
      <p>Teaches trade-offs and failure modes from real production experience.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsOtherWorkshops" :isPro=true>
      <p>Gives you live Q&A and direct support.</p>
    </ProOrCon>

    <!-- vs. isolated resources -->
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p><strong>Structured learning path</strong> that covers all essential topics.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p>Consistent teaching style, methodology and quality.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p>Practical advice illustrated with <strong>real-world examples</strong>.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p>Receive <strong>tailored advice</strong> for your specific challenges.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p>Learn from your peers and expand your professional network at the same time.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p><strong>Continuously updated</strong> to align with latest industry trends and best practices.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p><strong>More cost-effective</strong> than purchasing multiple courses.</p>
    </ProOrCon>
    <ProOrCon v-if="state.vsIsolatedResources" :isPro=true>
      <p>Your one-stop shop to give you a <strong>complete understanding of serverless architectures</strong>.</p>
    </ProOrCon>
  </div>
</template>

<script>
import ProOrCon from './ProOrCon.vue'

export default {
  props: ['state'],
  components: {
    ProOrCon
  }
}
</script>
